import { Link } from "react-router-dom";

export const SpeciaRing = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
    <defs>
      <linearGradient id="specia-ring" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FF6B3D" />
        <stop offset="50%" stopColor="#7C3AED" />
        <stop offset="100%" stopColor="#2A1E9E" />
      </linearGradient>
    </defs>
    <circle cx="16" cy="16" r="12" fill="none" stroke="url(#specia-ring)" strokeWidth="4"
      strokeDasharray="1.6 1.6" strokeLinecap="butt" />
  </svg>
);

export default function SpeciaLogo({ to = "/", compact = false, testId = "nav-logo" }) {
  return (
    <Link to={to} data-testid={testId} className="flex items-center gap-3 group">
      <SpeciaRing size={compact ? 26 : 30} />
      <span className="leading-none">
        <span className="block font-heading font-bold text-[#2A1E9E] text-xl tracking-tight lowercase">specia</span>
        {!compact && <span className="block text-[9px] tracking-[0.18em] text-[#3A2DB8]/80 mt-0.5 lowercase">autonomous ai systems</span>}
      </span>
      <span className="hidden sm:block h-6 w-px bg-border mx-1" />
      <span className="hidden sm:inline neon-word text-sm">TRINITY</span>
    </Link>
  );
}
